import { useCallback } from '@wordpress/element';

/**
 * Custom hook to calculate widget dimensions based on aspect ratio
 * @param {string} aspect_ratio - Aspect ratio in format "16:9"
 * @return {Object} Functions to get dimensions
 */
const useDimensions = (aspect_ratio) => {
	// Calculate initial dimensions based on aspect ratio
	const getDimensions = useCallback(() => {
		const dimensionsMap = {
			'16:9': { width: 160, height: 90 },
			'4:3': { width: 160, height: 120 },
			'1:1': { width: 130, height: 130 },
			'9:16': { width: 130, height: 231 },
		};
		return dimensionsMap[aspect_ratio] || dimensionsMap['9:16'];
	}, [aspect_ratio]);

	// Calculate expanded dimensions for mobile
	const getExpandedDimensions = useCallback(() => {
		if (window.innerWidth > 768) {
			return null;
		}

		const maxH = window.innerHeight * 0.9;
		const maxW = window.innerWidth * 0.93;
		const [ratioW, ratioH] = aspect_ratio.split(':').map(Number);
		const aspectValue = ratioW / ratioH;

		let h = maxH;
		let w = h * aspectValue;

		if (w > maxW) {
			w = maxW;
			h = w / aspectValue;
		}

		return { width: w, height: h };
	}, [aspect_ratio]);

	return {
		getDimensions,
		getExpandedDimensions,
	};
};

export default useDimensions;
